var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_469_7216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6915 18.292C14.4416 19.8489 11.781 20.6798 9.04791 20.6798C8.74678 20.6798 8.44495 20.6697 8.14246 20.6494C5.97435 20.5038 3.89843 19.8427 2.0752 18.74C2.49425 19.3521 2.97244 19.9301 3.5083 20.4661C5.77554 22.7333 8.78997 23.9819 11.9963 23.9819C14 23.9819 15.9287 23.4943 17.647 22.5752C17.5921 21.1012 17.2667 19.6469 16.6915 18.292Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1928 0.174805C11.4964 0.964295 9.16034 2.67551 7.58319 5.02775C6.01476 7.36696 5.3213 10.1636 5.60667 12.9555C7.58361 12.9555 9.55797 12.4626 11.3078 11.5245C11.3817 9.27629 12.0163 7.08084 13.1543 5.14887C14.11 3.52652 15.399 2.12014 16.924 1.02647C16.0544 0.634657 15.1387 0.348767 14.1928 0.174805Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.223 11.5711C18.9816 9.04355 16.9068 7.04485 14.3467 5.896C13.3376 7.62184 12.7761 9.58105 12.7129 11.5873C14.6229 12.7754 16.2069 14.4227 17.311 16.3742C18.2431 18.0217 18.8175 19.8518 18.999 21.7298C19.522 21.3525 20.0188 20.9312 20.4837 20.4663C20.6991 20.2509 20.9052 20.0287 21.102 19.8002C21.7918 17.0471 21.4835 14.1375 20.223 11.5711Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18626 12.8685C3.92762 9.82712 4.70614 6.79262 6.41491 4.24409C7.59664 2.48158 9.16066 1.04168 10.9717 0.0180664C8.15177 0.254862 5.53211 1.46622 3.50809 3.49019C1.33843 5.65985 0.102455 8.51387 0 11.5653C1.30439 12.2508 2.7262 12.6925 4.18626 12.8685Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9558 12.7729C10.0062 13.8147 7.8297 14.362 5.62717 14.362V14.3615C3.39355 14.3615 1.76051 13.9307 0.0488281 13.1547C0.138388 14.0815 0.334155 14.9855 0.629048 15.8531C2.67355 17.8509 5.36444 19.0532 8.23633 19.246C11.0328 19.4338 13.7892 18.6448 16.0584 17.0173C15.0687 15.2875 13.6564 13.8275 11.9558 12.7729Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1377 4.71135C17.8983 6.00838 20.1348 8.19866 21.4866 10.9509C22.4331 12.8779 22.8982 14.9787 22.8674 17.0834C23.6092 15.5065 24.0005 13.7725 24.0005 11.9782C24.0005 8.7718 22.7518 5.75737 20.4846 3.49009C19.8248 2.8303 19.1014 2.25744 18.3287 1.77588C17.0971 2.5544 16.0145 3.55142 15.1377 4.71135Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_469_7216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoly);
export default __webpack_public_path__ + "static/media/VOLY.e675a5de4a32a7525bfb6a9cdc6978df.svg";
export { ForwardRef as ReactComponent };